const prefix = '/api';

const apiUrls = {
    global: {
        config: prefix + '/global/config',
        language: prefix + '/global/language',
        translations: prefix + '/global/translations',
        translationsMissing: prefix + '/global/translations-missing',
        signupDefaults: prefix + '/global/signup-defaults',
        miniBanners: prefix + '/global/mini-banner',
        refreshData: prefix + '/global/refresh-data',
    },
    games: {
        list: prefix + '/games',
        sortedFilters: prefix + '/games/sortedFilters',
        openGame: prefix + '/games/play',
        random: prefix + '/games/random',
        favoriteGame: prefix + '/games/favourite',
        jackpotDetails: prefix + '/games/jackpot-details',
        lobbies: prefix + '/games/lobby',

        racing: prefix + '/games/racing',

        roomsList: prefix + '/battle/rooms',
        myRoomsList: prefix + '/battle/my-rooms',
        battleGamesList: prefix + '/battle/games',
        createRoom: prefix + '/battle/create',
        joinRoom: prefix + '/battle/join',
        leaveRoom: prefix + '/battle/leave',
        roomInfo: prefix + '/battle/info',
        brands: prefix + '/battle/brands',
        battlesBanner: prefix + '/battle/banner',
    },
    virtual: {
        play: prefix + '/virtual/play',
    },
    user: {
        signup: prefix + '/user/signup',
        simpleSignup: prefix + '/user/simple-signup',
        simpleSignupCode: prefix + '/user/check-code',
        forgotPasswordSMS: prefix + '/user/forgot-password-sms',
        forgotPasswordCode: prefix + '/user/check-password-code',
        session: prefix + '/global/session',
        login: prefix + '/user/login',
        getAutologinCode: prefix + '/user/login-code',
        autologin: prefix + '/user/auto-login',
        logout: prefix + '/user/logout',
        authGoogle: prefix + '/user/auth-google',
        authSms: prefix + '/user/auth-sms',
        resendSms: prefix + '/user/resend-sms',
        forgetPassword: prefix + '/user/forgot-password',
        resetPassword: prefix + '/user/reset-password',
        changePassword: prefix + '/user/change-password',
        // Cabinet
        deposits: prefix + '/account/deposits',
        withdraws: prefix + '/account/withdraws',
        withdrawStatus: prefix + '/account/requests',
        accountReport: prefix + '/account/report',
        accountHistory: prefix + '/account/history',
        affiliates: prefix + '/account/affiliates',

        cashoutCheck: prefix + '/account/active-coupon',
        activeBets: prefix + '/account/active-coupons',
        getCashout: prefix + '/coupon/cashout',

        widgets: prefix + '/widgets',

        betHistory: prefix + '/account/coupons',
        betHistoryDetails: prefix + '/account/coupon-detail',
        shopBetDetails: prefix + '/shop/coupon-detail',
        betDelete: prefix + '/account/coupon-delete',
        casinoReport: prefix + '/account/casino',
        limits: prefix + '/account/limits',
        myInfo: prefix + '/account/info',
        updatePersonalInfo: prefix + '/account/update-personal-info',
        googleQrCode: prefix + '/user/google-qr-code',
        googleAuth: prefix + '/user/google-auth-set',
        verifyMail: prefix + '/user/verify-mail',
        invitations: prefix + '/user/sb-invitation',
    },
    betting: {
        sports: prefix + '/prematch/sports',
        rangedByDateSports: prefix + '/prematch/pre-sport',
        getWidget: prefix + '/prematch/pre-featured',
        widgetLogs: prefix + '/prematch/pre-featured',
        sportMatches: prefix + '/prematch/sport-matches',
        //---
        categories: prefix + '/prematch/categories',
        //---
        tournaments: prefix + '/prematch/tournaments',
        popularTournaments: prefix + '/prematch/popular-tournaments',
        //---
        allMarkets: prefix + '/prematch/all-markets',
        allCustomMarkets: prefix + '/prematch/all-custom-markets',
        //---
        topMatches: prefix + '/prematch/top-matches',
        favortieMatches: prefix + '/prematch/favorite-matches',
        matches: prefix + '/prematch/tournament-matches',
        match: prefix + '/prematch/match',
        matchTV: prefix + '/prematch/tv-channels',
        categoryMatches: prefix + '/prematch/category-matches',
        // ---
        outrights: prefix + '/outright/events',
        outrightBets: prefix + '/outright/bets',
        // ---
        matchPlayers: prefix + '/static/match-players',
        // ---
        coupons: {
            list: prefix + '/coupon',
            add: prefix + '/coupon/add',
            addVaix: prefix + '/coupon/add2',
            clear: prefix + '/coupon/clear',
            remove: prefix + '/coupon/remove',
            removeVaix: prefix + '/coupon/remove2',
            payout: prefix + '/coupon/payout',
            payoutSingle: prefix + '/coupon/payout-single',
            getBettingCode: prefix + '/shop/coupon-code',
            save: prefix + '/coupon/save',
            saveSingle: prefix + '/coupon/save-single',
        },

        vaix: {
            getRecommendation: prefix + '/vaix/betslips-recommended',
            sendStats: prefix + '/vaix/tracker',
        },

        search: prefix + '/prematch/search',

        // ##========================================================================================
        // ##                                                                                      ##
        // ##                                     Live betting                                     ##
        // ##                                                                                      ##
        // ##========================================================================================

        liveMatches: prefix + '/live/matches',
        liveAllMarkets: prefix + '/live/all-markets',
        liveAllCustomMarkets: prefix + '/live/all-custom-markets',
        liveCalendar: prefix + '/live/calendar',
        liveSportsList: prefix + '/live/sports',
        liveStream: prefix + '/live/stream',
    },
    favorite: {
        tournamentsList: prefix + '/favorites/tournaments',
        tournamentToggle: prefix + '/favorites/tournament',
        tournamentMatches: prefix + '/favorites/tournament-matches',
        tournamentSearch: prefix + '/favorites/tournament-search',
        teamToggle: prefix + '/favorites/team',
        teamList: prefix + '/favorites/teams',
        teamMatches: prefix + '/favorites/team-matches',
        teamSearch: prefix + '/favorites/team-search',
        marketsList: prefix + '/favorites/markets',
        marketToggle: prefix + '/favorites/market',
    },
    promo: {
        getPromo: prefix + '/global/bonus',
        sendPromo: prefix + '/account/bonus',
    },
    logs: {
        errorLogger: '/weblog',
    },
    messages: {
        list: prefix + '/messages',
        create: prefix + '/messages/create',
        update: prefix + '/messages/update',
    },
    help: {
        menu: prefix + '/help/menu',
        articles: prefix + '/help/articles',
    },
};

export default apiUrls;
